<template>
  <div>
    <toggle-details class="" @click="show = !show" v-b-toggle.error-details>
      <slot name="default"></slot>
    </toggle-details>
    <b-collapse id="error-details">
      <table class="table">
        <thead>
          <th class="p-2 pb-3" scope="col">Sor</th>
          <th class="p-2 pb-3" scope="col">Hibaüzenet</th>
        </thead>
        <tbody>
          <tr
            v-for="(error, index) in errorsList"
            :key="`e${index}`"
          >
            <td class="p-2 font-weight-bold">{{ error.row }}</td>
            <td class="p-2">{{ error.message }}</td>
          </tr>
        </tbody>
      </table>
    </b-collapse>
  </div>
</template>
<script>
import OpenFadeDownTransition from '../common/OpenFadeDownTransition'
import ToggleDetails from '../common/ToggleDetails'
import {dataMembers} from './ColumnAssociation'

export default {
  components: {
    'open-fade-down-transition': OpenFadeDownTransition,
    'toggle-details': ToggleDetails
  },
  props: {
    errors: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  data() {
    return {
      show: false,
    }
  },
  computed: {
    errorsList() {
      return _.map(this.errors, (message, row) => ({
        message: _.reduce(message, (result, element, key) => {
          var value = ''
          if(!isNaN(parseInt(key))) {
            value = element
          } else {
            var member = this.getMember(key)
            if(typeof member === 'undefined') {
              value = `${key}: ${element}`
            } else {
              value = `${member.label}: ${element}`
            }
          }

          return `${result} ${value}`
        }, ''),
        row
      }))
    }
  },
  methods: {
    getMember(key) {
      return _.find(dataMembers, member => member.name === key)
    }
  }
}
</script>